import React from 'react';

const Payments = ({ fill = '' }: { fill?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8921 8.03404V6.06975H6.72545V8.03404H15.8921ZM15.8921 4.10547C16.2394 4.10547 16.5725 4.24344 16.8181 4.48902C17.0637 4.7346 17.2016 5.06769 17.2016 5.41499V11.9626C17.2016 12.3099 17.0637 12.643 16.8181 12.8886C16.5725 13.1342 16.2394 13.2721 15.8921 13.2721H6.72545C6.37814 13.2721 6.04506 13.1342 5.79947 12.8886C5.55389 12.643 5.41592 12.3099 5.41592 11.9626V5.41499C5.41592 5.06769 5.55389 4.7346 5.79947 4.48902C6.04506 4.24344 6.37814 4.10547 6.72545 4.10547H15.8921ZM4.1064 14.5817H13.9278V15.8912H4.1064C3.75909 15.8912 3.42601 15.7532 3.18043 15.5076C2.93484 15.262 2.79688 14.929 2.79688 14.5817V7.37928H4.1064V14.5817Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

export default Payments;
